import { define } from 'wicked-elements'

define('[data-component~="publication-column"]', {
  init () {
    this.desktop = matchMedia('(min-width: 1024px)')
    this.update = this.update.bind(this)
  },
  connected () {
    this.observer = new ResizeObserver(this.update)
    this.observer.observe(this.element)
    window.addEventListener('resize', this.update)
    this.update()
  },
  disconnected () {
    this.observer?.disconnect()
    window.removeEventListener('resize', this.update)
  },
  update () {
    const gutter = 6 * parseFloat(getComputedStyle(document.documentElement).fontSize)
    const contentHeight = this.element.getBoundingClientRect().height
    const fits = contentHeight <= innerHeight - gutter * 2

    this.element.classList.toggle('is-sticky', this.desktop.matches && fits)
  }
})
